import { Tooltip, Box } from '@cast/design-system';

import { useEscalationBadgeState } from 'hooks/useEscalationBadgeState';

type OrganizationBadgeProps = {
  isEscalation?: boolean;
  isBlocked?: boolean;
};

export const OrganizationBadge = ({
  isEscalation,
  isBlocked,
}: OrganizationBadgeProps) => {
  const badgeState = useEscalationBadgeState({
    isEscalation: !!isEscalation,
    isBlocked: !!isBlocked,
  });

  if (!badgeState) {
    return null;
  }

  const { title, sx, Icon } = badgeState;

  return (
    <Tooltip title={title} placement="right" enterNextDelay={300}>
      <Box sx={sx}>
        <Icon size={12} weight="fill" />
      </Box>
    </Tooltip>
  );
};
